var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditMemo = function SvgCreditMemo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E3330",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20.01 22.013V3.322a1.335 1.335 0 0 0-1.335-1.336H5.325A1.335 1.335 0 0 0 3.99 3.322v18.69l2.67-2.67 2.67 2.67 2.67-2.67 2.67 2.67 2.67-2.67z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#2E3330",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#credit-memo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 11.667 9.334 10 11 8.333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.667 13.667v-2.334A1.333 1.333 0 0 0 13.334 10h-4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "credit-memo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 7h8v8H8z"
  })))));
};
export default SvgCreditMemo;